import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Input, Col, Row } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import './index.css';
import DataObject from '../../components/DataObject';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class TagScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tag: {
                id: parseInt(this.props.match.params.tag_id, 10) || '',
            },
            searchKeyword: '',
            searchResults: [],
            searchResultCount: 0,
            isSearching: false,
            currentUser: null,
        }
    }
    componentWillMount() {
        this.getCurrentUser();
        this.search();
    }
    componentDidMount = () => {
        document.title = "DataDex";
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: 'user/me',
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ currentUser: response.user })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    search() {
        const { tag } = this.state;
        api.fetchAPI({
            method: 'get',
            uri: `tag/${tag.id}`,
            success: (response) => {
                this.setState({
                    tag: response,
                });
            },
            error: (error) => {
              console.error(error);
            }
        });
        this.setState({ isSearching: false });
    }
    render() {
        const { searchKeyword, searchResultCount, searchResults, tag, currentUser } = this.state;
        return (
            <div style={{ marginTop: 50 }}>
                <Row>
                    <Col xs={12}>
                        <h4>{tag.stats && tag.stats.tag_used_count} objects that are tagged with "<span className="tag-screen-code_name">{tag.code_name}</span>"</h4>
                    </Col>
                </Row>
                <Row>
                    {tag.objects && tag.objects.map(result =>
                        <Col xs={12}  className="home-search-result-item" key={`${result.object_type}_${result.id}`}>
                            <DataObject dataObject={result} />
                        </Col>
                    )}
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/TagScreen/index.js